<div style="min-height: 100vh; height: 100%;">
  <ng-container *ngIf="isAuthenticated$ | async; else loginPage">
    <app-toast></app-toast>
    <app-sidenav>
      <router-outlet></router-outlet>
    </app-sidenav>
  </ng-container>

  <ng-template #loginPage>
    <app-toast></app-toast>
    <router-outlet></router-outlet>
  </ng-template>
</div>